import axios from '@/axios.js';
// import axios from 'axios'

export default {
  getBankCashflow (context, payload) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/v1/bank-account-cashflow?bank_account_id=${payload.bank_account_id}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  findBankCashflow (context, id) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/v1/bank-account-cashflow/${id}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  createBankCashflow (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/v1/bank-account-cashflow', payload)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateBankCashflow (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post(`/api/v1/bank-account-cashflow/${payload.id}`, payload.data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  deleteBankCashflow (context, id) {
    return new Promise((resolve, reject) => {
      axios.delete(`/api/v1/bank-account-cashflow/${id}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }
}
